module.exports = __webpack_public_path__ + "img/icon6.60f5c0e6.svg";